<template>
  <div
    class="panel panel-default"
    :class="panelClass">
    <button
      class="panel-heading"
      :aria-expanded="expanded ? 'true' : 'false'"
      @click="togglePanel">
      {{ levelLabelMapping[level] }}
      <span class="label label-info pull-right" v-if="edited"><i class="fa fa-pencil" aria-hidden="true"/>&nbsp; Edited</span>
    </button>
    <collapse v-model="expanded">
      <div class="panel-body gb-text-3">
        <slot name="body"/>
      </div>
      <div class="panel-footer goal-footer-text" v-if="footer">
        <GoalExampleContent>
          <slot name="footer"/>
        </GoalExampleContent>
      </div>
    </collapse>
  </div>
</template>

<script>
import GoalExampleContent from '@/components/goals/GoalExampleContent'

export default {
  name: 'AdaptedGoalView',
  components: {
    GoalExampleContent
  },
  props: {
    level: {
      type: String,
      required: true
    },
    position: {
      type: Number,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true
    },
    footer: {
      type: Boolean,
      default: false
    },
    edited: {
      type: Boolean,
      default: false
    },
    levelLabelMapping: {
      type: Object,
      required: true
    }
  },
  computed: {
    panelClass() {
      let classModifier = this.level.toLowerCase()
      if (['mild', 'moderate', 'intense'].indexOf(classModifier) == -1) {
        classModifier = 'mild'
      }
      return `panel-default--${classModifier} panel-toggle`
    }
  },
  eventContext() {
    return {
      adapted_goal_level: this.level
    }
  },
  methods: {
    togglePanel() {
      this.$emit('toggle', this.position)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
.panel.panel-default {
  .panel-heading {
    border: none;
    width: 100%;
    text-align: left;
    color: @link-color;
    font-size: 16px;
    &:hover {
      text-decoration: underline;
    }
  }
  &.panel-default--mild .panel-heading {
    background: #f0fbff;
  }
  &.panel-default--moderate .panel-heading {
    background: #e5f9ff;
  }
  &.panel-default--intense .panel-heading {
    background: #daf6fe;
  }

  .panel-body, .panel-footer {
    box-shadow: 1px 1px 1px rgb(0 0 0 / 5%);
  }
  .panel-body {
    border: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
  }
  .panel-footer {
    padding: 0;
    background-color: white;
    overflow: hidden;
  }
}
</style>
